import { render, staticRenderFns } from "./HorizontalNav.vue?vue&type=template&id=4ce40b1e&scoped=true&"
import script from "./HorizontalNav.vue?vue&type=script&lang=js&"
export * from "./HorizontalNav.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNav.vue?vue&type=style&index=0&id=4ce40b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce40b1e",
  null
  
)

export default component.exports